<script setup lang="ts">
import useUserStore from '~/store/user'
import TeslaCarousel from './TeslaCarousel.vue'
import { TeslaLinkStatus } from '~/interfaces/user'

const emits = defineEmits(['close'])

const { locale } = useI18n()
const userStore = useUserStore()

const isInitiated = computed(
    () => userStore.userTeslaLinkStatus === TeslaLinkStatus.INITIATED
)

const isConfirmed = computed(
    () => userStore.userTeslaLinkStatus === TeslaLinkStatus.CONFIRMED
)

const onClickOnLinkPass = () => {
    const newWnd = window.open('https://ts.la/app', '_top')

    if (newWnd) {
        newWnd.opener = null
    }
}

const onClickOnPurchase = () => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            { action: 'openUrl', url: 'pass/step1' },
            document.referrer
        )
    } else {
        const newWnd = window.open(
            getChargemapUrl('/pass/step1', locale.value),
            '_top'
        )

        if (newWnd) {
            newWnd.opener = null
        }
    }
}
</script>

<template>
    <div
        class="z-10 relative w-screen h-screen flex justify-center items-center font-inter"
    >
        <span
            class="bg-black opacity-40 h-screen w-screen absolute"
            @click="emits('close')"
        />
        <div
            class="bg-white shadow-global-1 rounded-xl z-10 w-3/4 max-w-md max-h-screen overflow-auto min-w-300"
        >
            <div v-if="isInitiated || isConfirmed">
                <h2
                    class="text-center font-bold text-4xl leading-10 tracking-tight text-gray-l-700 px-1 md:px-6 mt-4 mb-6"
                >
                    <span class="text-red-tesla">
                        {{
                            isInitiated
                                ? $t('tesla.modal.pending.title1')
                                : $t('tesla.modal.activated.title1')
                        }}
                    </span>
                    {{
                        isInitiated
                            ? $t('tesla.modal.pending.title2')
                            : $t('tesla.modal.activated.title2')
                    }}
                </h2>
                <TeslaCarousel
                    :has-pass="userStore.userAlreadyHasAPass"
                    :is-tesla-link-confirmed="isConfirmed"
                    :is-tesla-link-initiated="isInitiated"
                />
                <div class="m-4">
                    <ChargemapB2CButton
                        type="primary"
                        size="large"
                        custom="full-width"
                        @click="emits('close')"
                    >
                        {{ $t('ok') }}
                    </ChargemapB2CButton>
                </div>
            </div>
            <div v-else>
                <h2
                    class="text-center font-bold text-4xl leading-10 tracking-tight text-gray-l-700 px-1 md:px-6 mt-4 mb-6"
                >
                    {{ $t('tesla.modal.title1') }}
                    <span class="text-red-tesla">
                        {{ $t('tesla.modal.title2') }}
                    </span>
                </h2>
                <TeslaCarousel
                    :has-pass="userStore.userAlreadyHasAPass"
                    :is-tesla-link-confirmed="isConfirmed"
                    :is-tesla-link-initiated="isInitiated"
                />
                <div class="flex flex-col gap-6 m-4">
                    <ChargemapB2CButton
                        type="primary"
                        size="large"
                        custom="full-width"
                        @click="
                            userStore.userAlreadyHasAPass
                                ? onClickOnLinkPass
                                : onClickOnPurchase
                        "
                    >
                        {{
                            userStore.userAlreadyHasAPass
                                ? $t('tesla.modal.link_pass')
                                : $t('word.purchase')
                        }}
                    </ChargemapB2CButton>
                    <ChargemapB2CButton
                        type="tertiary"
                        size="small"
                        variant="black"
                        @click="emits('close')"
                    >
                        {{ $t('word.later') }}
                    </ChargemapB2CButton>
                </div>
            </div>
        </div>
    </div>
</template>
